import React from 'react';

import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
// import Modal from './assets/js/modals/modals';
import './App.scss';
import Home from './assets/js/home';

function App() {
  // console.log(process.env);

  return (
    <Router>
      <div className="App">
        <Switch>
          <Route exact path="/" component={Home} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
